import { ModalContent, ModalFooter } from '@src/app-components/secondary-modal';
import UserCard from '@src/app-components/user-card/UserCard';
import { Alert } from '@trussworks/react-uswds';
import { useModal } from '@src/stores';

const RemoveUserConfirmationModal = ({ user, onConfirm = () => {} }) => {
  const { closeSecondaryModal } = useModal();

  const handleRemoveUserConfirmation = () => {
    onConfirm(user);
    closeSecondaryModal();
  };

  const handleCancel = () => {
    closeSecondaryModal();
  };

  return (
    <ModalContent title='Are you sure you want to remove request access for this user?' size='small'>
      <section className='modal-body'>
        <div className='label-value'>
          <b>The following user will lose access to this request:</b>
        </div>
        <div className='user-card-container'>
          <div className='margin-bottom-1'>
            <UserCard user={user} showSelectRole={false} />
          </div>
        </div>
        <Alert type='warning' slim>
          This user will no longer have access to this request.
        </Alert>
      </section>
      <ModalFooter saveText='Confirm' onSave={handleRemoveUserConfirmation} onCancel={handleCancel} showCancelButton />
    </ModalContent>
  );
};

export default RemoveUserConfirmationModal;
